import React from "react";
import Api from "../api/Api";
import { FormContext } from "./FormContext";
import Confirm from "../layout/Confirm";

export default class FileInput extends React.Component {
	static contextType = FormContext;

	static id = 1;

	constructor(props) {
		super(props);
		this.state = {
			file: null,
			files: null,
			error: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setError = this.setError.bind(this);
		this.htmlId = "i" + FileInput.id++;
	}

	setValue(value) {
		this.setState({ value: value });
		this.context.setValue(this.props.name, value);
	}

	setError(error) {
		this.setState({ error: error });
	}

	handleChange(e) {
		let value = e.target.value;
		let files = e.target.files;
		if (files.length == 0) {
			value = null;
			files = null;
		}
		this.setState({ value: value, files: files }, () => {
			if (this.props.onChange)
				this.props.onChange(e);
		});
		this.context.setValue(this.props.name, files);
	}

	componentDidMount() {
		let hasFile = false;
		if (this.props.document) {
			this.setState({ file: this.props.document });
			hasFile = true;
		}
		this.context.initInput(this.props.name, hasFile ? 'keep' : null, this.setValue, this.setError);
		this.context.hasFiles();
	}

	componentWillUnmount() {
		this.context && this.context.removeInput(this.props.name);
	}

	//componentDidUpdate(prevProps) {
	//    if (JSON.stringify(prevProps.documents) !== JSON.stringify(this.props.documents))
	//        this.componentDidMount();
	//}

	deleteFile = () => {
		Confirm(() => {
			this.setState({ file: null }, () => {
				if (this.props.onChange)
					this.props.onChange();
			});
			this.context.setValue(this.props.name, 'deleted');
		});
	}

	removeFile = () => {
		this.setState({ value: null, files: null }, () => {
			if (this.props.onChange)
				this.props.onChange(null);
		});
		this.context.setValue(this.props.name, null);
	}

	render() {
		let file = this.state.file;

		return (
			//<div className={"form-group" + (this.props.required && !file && !this.state.value ? ' required' : '') + (this.props.wide ? ' wide' : '')} >
			//<div className="form-control-wrap">
			<div className="mb-1 input-group">
				{file ?
					<>
						<div className="form-control disabled pointer" onClick={() => Api.download('download', { Id: file.id + '' })}><em className="fa-solid fa-download"></em> {file.name.shorten(20, 4)} ({t.fileSize(file.size)})</div>
						{!this.props.readOnly && <span className="btn btn-danger d-flex align-items-center" onClick={this.deleteFile}><i className="fa-solid fa-trash"></i></span>}
					</>
					: this.state.value ?
						<>
							<div className="form-control">
								{this.state.files[0].name}
							</div>
							<span className="btn btn-danger d-flex align-items-center" onClick={this.removeFile}><i className="fa-solid fa-trash"></i></span>
						</>
						: <input type="file" required={this.props.required && !file} multiple={this.props.multiple} onChange={this.handleChange} disabled={this.props.readOnly || this.context.readOnly} className={"form-control" + (this.state.error ? " is-invalid" : '')} id={this.htmlId} />
				}
				{this.state.error && <span className="invalid-feedback">{this.state.error}</span>}
			</div>
			//</div>
			//</div>
		);
	}
}